import { createContext, useState, ReactNode } from 'react'

interface MenuProviderProps {
    children: ReactNode;
}

interface MenuContextProps {
    statusMenu: boolean;
    toggleMenu: () => void;
}

export const MenuContext = createContext<MenuContextProps>({} as MenuContextProps)

export function MenuProvider({ children }: MenuProviderProps) {
    const [statusMenu, setStatusMenu] = useState(false)


    function toggleMenu() {
        setStatusMenu(!statusMenu)
    }

    return (
        <MenuContext.Provider
            value={{ statusMenu, toggleMenu }}
        >
            {children}
        </MenuContext.Provider>
    );
}